import qs from 'qs';

const filterFunc = (prefix, value) => {
    const filter = ['locale', 'currency', 'apply', 'mode', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'];
    if (filter.includes(prefix)) return;
    return value;
};

export default (search) => {
    const current = qs.parse(search, {ignoreQueryPrefix: true});
    return qs.stringify(
        {
            ...current
        },
        {
            filter: filterFunc,
            addQueryPrefix: true
        }
    );
};